// extracted by mini-css-extract-plugin
module.exports = {"DedicatedCustomer":"DedicatedCustomer_DedicatedCustomer__UW3Qf","slideIn":"DedicatedCustomer_slideIn__hBKLD"};